export const searchTypeShort = {
  activity: "ACTIVITY",
  restaurant: "RESTAURANT",
  hotel: "HOTEL",
  flight: "FLIGHT",
  dynamicPackage: "DP",
  optionalTour: "TOUR",
  cruise: "CRUISE",
};
